import * as React from 'react';
import { BaseForm } from './Base';
import theme from '../../utils/theme';

const base = (props: any) => {
  const opacity = props.disabled ? 'o-50' : 'o-100';

  return `${theme.form.field.input} ${opacity}`;
};

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export interface Props extends InputProps {
  id: string;
  label: string;
  tooltip?: string;
  field: any;
  onValueChange: Function;
  defaultValue: any;
}

export const PriceField = ({
  label,
  id,
  tooltip,
  field,
  type,
  onValueChange,
  ...rest
}: Props) => (
  <BaseForm label={label} id={id} tooltip={tooltip}>
    <input
      className={base(rest)}
      id={id}
      type="number"
      onChange={(e) => onValueChange(field, parseFloat(e.target.value || '0') * 100)}
      {...rest}
      defaultValue={String(rest.defaultValue / 100)}
    />
  </BaseForm>
);

export default PriceField;
